import { render, staticRenderFns } from "./TopArticulosVendidos.vue?vue&type=template&id=24edbae0"
import script from "./TopArticulosVendidos.vue?vue&type=script&lang=js"
export * from "./TopArticulosVendidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports